import React, {FC, ReactNode} from 'react';
import {PortalContext, IPortalContextProps} from 'modules/portal/context/PortalContext';

interface IProps extends IPortalContextProps {
    children: ReactNode;
}
export const PortalProvider: FC<IProps> = ({name, onClose, children, visibility}) => {
    return <PortalContext.Provider value={{name, onClose, visibility}}>{children}</PortalContext.Provider>;
};
